import React from "react";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import {
  AppBar,
  Grid,
  Hidden,
  IconButton,
  Paper,
  Toolbar,
  Typography,
  LinearProgress
} from "@material-ui/core";
import { Menu } from "@material-ui/icons";
import ProfileMenu from "./ProfileMenu";
import LayoutDrawer from "./LayoutDrawer";
import UserStore from "../stores/UserStore";
import BaseStore from "../stores/BaseStore";
import RequestNotificationPermission from "./RequestNotificationPermission";
import { withRouter } from "react-router";
import styles from "./LayoutStyle";
import pathName from "../PathToName";
import SearchBar from "./SearchBar";
import withSnack from "./withSnack";
import Tour from "reactour";
import Footer from './Footer'
import DelegateStore from '../stores/DelegateStore';
import NotificationsArea from "./NotificationsArea";

export class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isLoanding: false,
      isAuth: UserStore.isAuth(),
      openTour: false,
      optionsTour: [],
      // badges: {
      //   inbox: UserStore.info().badges_inbox,
      //   pending: UserStore.info().badges_pending,
      //   review: UserStore.info().badges_review
      // },
      badges: {
        inbox: 0,
        pending: 0,
        review: 0
      },
      params: {
        ...UserStore.info(),
        hasDelegates: false,
        isDelegate: false,
        isReviewer: false
      },
      blockedWindow: UserStore.info().verified === 'true'? false : true,
      isOpenModalSupport: false
    };

    //I add some interceptors to have a loading bar when a request is slow
    BaseStore.addInterceptorLoanding(
      s => {
        this.setState({ isLoanding: s });
      },
      s => {
        if (s === true) this.props.snack("Cargando", 'warning');
      }
    );
  }

  toggleDrawer = () => {
    this.setState(ps => {
      return { open: !ps.open };
    });
  };

  signout = () => {
    UserStore.signout().then(a => {
      this.setState({ isAuth: a });
      this.props.history.push("/login");
    });
  };

  setParams = () => {
  //
    DelegateStore.getUsersOnBehalf().then(r => {
      if(r.data.length > 1){
        this.setState({ params: {...this.state.params, isDelegate: true } });
      }
    });

  //
    DelegateStore.listUsers('delegate').then(r => {
      if(r.data.length > 0){
        this.setState({ params: {...this.state.params, hasDelegates: true } });
      }
    });

  //
    DelegateStore.getUsersOnBehalfReviewer().then(r => {
      if(r.data.length > 1){
        this.setState({ params: {...this.state.params, isReviewer: true } });
      }
    });
  }

  setOptionsTour = () => {
    const tourConfig = [
      {
        selector: '[data-tut="toolbar"]',
        content: `Aquí puede acceder al menú de su administrador de oficios.`
      },
      {
        selector: '[data-tut="sidebar"]',
        content: `Estos son los elementos de su administrador de oficios.`
      },
      {
        selector: '[data-tut="profile"]',
        content: `Aquí puede identificar su cuenta de usuario.`
      },
      {
        selector: '[data-tut="profile-options"]',
        content: `Estas son las opciones relacionadas a su cuenta de usuario.`
      }
    ];

    // if user cannot create or is not a delegate delete option from tour
    if(this.state.params.can_create === 'false' && this.state.params.isDelegate === false){
      tourConfig.splice(2,1);
    }

    this.setState({optionsTour: tourConfig})
  }

  componentDidMount() {
    this.setOptionsTour();
    this.setParams();
  }

  componentDidUpdate(prevProps) {
    const isAuth = UserStore.isAuthenticated;
    if (this.state.isAuth !== isAuth) {
       this.setParams();
       this.setState({ isAuth: isAuth });
    }
  }

  closeTour = () => {
    this.setState({ openTour: false });
  };

  openTour = () => {
    this.setState({openTour: true})
  }

  inn = () => {
    if(this.state.open !== true){
      this.setState({open: true})
    }
  }

  out = () => {
    this.setState({open: false})
  }

  unlockWindow = () => {
    this.setState({ blockedWindow: false })
  }

  setReadNotifications = () => {
    UserStore.setReadNotifications(this.state.params.id).then(r => {

      if (r.data.status === 'ok') {
          UserStore.saveLocal("read_notifications", true);
          this.setState({ params: { ...this.state.params, read_notifications: 'true' } })
      }

    });
  }

  render() {

    const { classes } = this.props;
    const { isAuth, open, isLoanding, openTour, optionsTour, badges, params, blockedWindow } = this.state;
    const path = this.props.location.pathname;
    const not_new_oficio = (path !== '/oficios/new')
    const accentColor = "#8470a6";

    let mainClass = classes.root;

      if(blockedWindow === true){
          mainClass = classes.blocked;
      }

    return (
      <div className={mainClass}>
        {isAuth ? <RequestNotificationPermission /> : null}
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, open && classes.appBarShift)}
        >
          <Toolbar disableGutters={true}>
            <Grid
              container
              spacing={0}
              justify={"space-between"}
              direction={"row"}
              alignItems={"center"}
            >
              <Grid item sm={5} md={3} lg={3}>
                <IconButton
                  style={{ float: "left" }}
                  color="inherit"
                  aria-label="open drawer"
                  onClick={this.toggleDrawer}
                  className={classNames(classes.menuButton)}
                >
                  <Menu data-tut="toolbar"/>
                </IconButton>
                <Typography
                  variant="h6"
                  color="inherit"
                  noWrap
                  className="title"
                >
                  {path === '/404'? 'Página no encontrada' : pathName(path)}
                </Typography>
              </Grid>

              <Grid item xs={1} sm={5} md={5} lg={5} xl={5}>
                <SearchBar
                  isAuth={isAuth}
                  onChange={() => {}}
                  onRequestSearch={event => {}}
                  style={{
                    margin: "0 auto",
                    maxWidth: 800,
                    textAlign: "right"
                  }}
                />
              </Grid>
              <Grid item sm={2} md={'auto'} lg={'auto'} xl={3} style={{ display: "flex", justifyContent: "end" }}>
                <NotificationsArea
                    isOpen={false}
                    readNotifications={params.read_notifications === 'true'? true : false}
                    setReadNotifications={this.setReadNotifications}
                  />
                <ProfileMenu
                  isAuth={isAuth}
                  signout={this.signout}
                  info={params}
                  isOpen={openTour}
                  openTour={this.openTour}
                  allowTour={not_new_oficio}
                  unlockWindow={this.unlockWindow}
                />
              </Grid>
            </Grid>
          </Toolbar>
          {isLoanding ? <LinearProgress color="secondary" /> : null}
        </AppBar>
        <LayoutDrawer
          open={(openTour && isAuth && not_new_oficio)? true : open && isAuth? true : false }
          toggleOpen={this.toggleDrawer}
          classes={classes}
          isAuth={isAuth}
          can_create={params.can_create}
          isDelegate={params.isDelegate}
          isReviewer={params.isReviewer}
          can_grant={params.can_grant}
          inn={this.inn}
          out={this.out}
          badges={badges}
        />
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Hidden smDown>
            <br />
          </Hidden>
          <MainContent {...this.props}/>
        </main>
        {(isAuth && not_new_oficio)? (
          <Tour
           onRequestClose={this.closeTour}
           steps={optionsTour}
           isOpen={openTour}
           maskClassName="mask"
           className="helper"
           rounded={5}
           accentColor={accentColor}
           startAt={0}
         />
        ) : null}
        <Footer/>
      </div>
    );
  }
}

const MainContent = props => {

  const { classes, showPaper } = props;
    return (
      <Grid container>
        <Grid item lg={1} xl={2} md={1} sm={false} xs={false} />
        <Grid item lg={10} xl={8} md={10} sm={12} xs={12} style={{ paddingBottom: 182, minHeight: 'calc(100vh - 85px)' }}>
          <Paper className={showPaper?classes.rootPaper: classes.hiddenPaper}>{props.children}</Paper>
          <br />
        </Grid>
        <Grid item lg={1} xl={2} md={1} sm={false} xs={false} />
      </Grid>
    );
};

export default withSnack(
  withStyles(styles, { withTheme: true })(withRouter(Layout))
);



// WEBPACK FOOTER //
// ./src/components/Layout.js